<header class="flex items-center px-2 border-b dark:border-white/5 sticky z-50 top-0">
  <div (click)="viewSmallScreenMenu()" class="py-2.5 lg:hidden">
    <div
      class="relative flex min-w-0 items-center gap-3 rounded-lg p-2 text-left text-base/6 font-medium text-zinc-950 dark:text-white sm:text-sm/5 hover:bg-zinc-950/5 dark:hover:bg-white/5">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
        class="size-5">
        <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 9h16.5m-16.5 6.75h16.5" />
      </svg>
    </div>
  </div>
  <div class="min-w-0 flex-1">
    <div class="flex flex-1 items-center gap-4 py-1">
      <ul class="max-lg:hidden flex items-center gap-3">
        <li *ngFor="let menu of subMenus" class="relative">
          <span *ngIf="rla.isActive"
            class="absolute inset-x-2 -bottom-[5px] h-px rounded-full bg-zinc-950 dark:bg-white">
          </span>
          <a routerLink="{{menu.url}}" routerLinkActive #rla="routerLinkActive"
          [ngClass]="rla.isActive ? 'bg-zinc-950/5 dark:bg-white/5' : '' "
            class="relative flex min-w-0 items-center gap-3 rounded-lg p-2.5 text-left font-medium text-zinc-950 dark:text-white text-sm/5 hover:bg-zinc-950/5 dark:hover:bg-white/5"
            data-headlessui-state="" href="/demos/stacked" data-current="true">
            {{menu.title}}
          </a>
        </li>
      </ul>
      <div aria-hidden="true" class="-ml-4 flex-1"></div>
      <ul class="flex items-center gap-3">
        <li>
          <div (click)="toggleTheme()"
            class="cursor-pointer relative flex min-w-0 items-center gap-3 rounded-lg p-2 text-left text-base/6 font-medium text-zinc-950 dark:text-white sm:text-sm/5 hover:bg-zinc-950/5 dark:hover:bg-white/5">
            <svg *ngIf="isDarkMode" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
              stroke-width="1.5" stroke="currentColor" class="size-5">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M12 3v2.25m6.364.386-1.591 1.591M21 12h-2.25m-.386 6.364-1.591-1.591M12 18.75V21m-4.773-4.227-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z" />
            </svg>
            <svg *ngIf="!isDarkMode" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
              stroke-width="1.5" stroke="currentColor" class="size-5">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M21.752 15.002A9.72 9.72 0 0 1 18 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.748-3.752A9.753 9.753 0 0 0 3 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 0 0 9.002-5.998Z" />
            </svg>
          </div>
        </li>
        <li>
          <div (click)="toggleSound()" [ngClass]="!isSound ? 'text-red-600 dark:text-red-600' : 'text-zinc-950 dark:text-white'"
            class="relative flex min-w-0 items-center gap-3 rounded-lg p-2 text-left text-base/6 font-medium   sm:text-sm/5 hover:bg-zinc-950/5 dark:hover:bg-white/5 cursor-pointer">
            <svg *ngIf="isSound" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
              stroke="currentColor" class="size-5">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M19.114 5.636a9 9 0 0 1 0 12.728M16.463 8.288a5.25 5.25 0 0 1 0 7.424M6.75 8.25l4.72-4.72a.75.75 0 0 1 1.28.53v15.88a.75.75 0 0 1-1.28.53l-4.72-4.72H4.51c-.88 0-1.704-.507-1.938-1.354A9.009 9.009 0 0 1 2.25 12c0-.83.112-1.633.322-2.396C2.806 8.756 3.63 8.25 4.51 8.25H6.75Z" />
            </svg>
            <svg *ngIf="!isSound" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-5">
              <path stroke-linecap="round" stroke-linejoin="round" d="M17.25 9.75 19.5 12m0 0 2.25 2.25M19.5 12l2.25-2.25M19.5 12l-2.25 2.25m-10.5-6 4.72-4.72a.75.75 0 0 1 1.28.53v15.88a.75.75 0 0 1-1.28.53l-4.72-4.72H4.51c-.88 0-1.704-.507-1.938-1.354A9.009 9.009 0 0 1 2.25 12c0-.83.112-1.633.322-2.396C2.806 8.756 3.63 8.25 4.51 8.25H6.75Z" />
            </svg>            
          </div>
        </li>
        <li class="relative">
          <div (click)="openNotificationModal()" (mousedown)="$event.stopPropagation()"
            class="relative flex min-w-0 items-center gap-3 rounded-lg p-2 text-left text-base/6 font-medium text-zinc-950 dark:text-white sm:text-sm/5 hover:bg-zinc-950/5 dark:hover:bg-white/5">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
              stroke="currentColor" class="size-5">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0" />
            </svg>
            <span *ngIf="unreadNotificationCount > 0"
              class="absolute -top-1 -right-1 flex h-4 min-w-[1rem] items-center justify-center rounded-full bg-red-600 px-1 text-[10px] font-semibold leading-none text-white">
              {{ unreadNotificationCount > 99 ? '99+' : unreadNotificationCount }}
            </span>
          </div>
          <app-notification-modal *ngIf="showNotifications" (closeModal)="showNotifications = false"></app-notification-modal>
        </li>
        <li class="relative">
          <div (click)="showUserOptions = !showUserOptions"
            class="border border-dashed border-[#80808075] p-[5px] relative flex min-w-0 items-center gap-3 rounded-lg text-left text-base/6 font-medium text-zinc-950 dark:text-white sm:text-sm/5 hover:bg-zinc-950/5 dark:hover:bg-white/5 cursor-pointer">
            <div>{{user.name | capitalize}}</div>
            <div
              class="w-7 inline-grid shrink-0 align-middle [--avatar-radius:20%] [--ring-opacity:20%] *:col-start-1 *:row-start-1 outline outline-1 -outline-offset-1 outline-black/[--ring-opacity] dark:outline-white/[--ring-opacity] rounded-[--avatar-radius] *:rounded-[--avatar-radius]">
              <img src="{{user.profileImageURL ? user.profileImageURL : 'assets/images/company-placeholder.png'}}"
                class="size-full" alt="">
            </div>
            
          </div>
          <div *ngIf="showUserOptions" @openCloseProfile
            class="absolute right-0 z-50 mt-2 w-40 origin-top-right rounded-md  bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 shadow-lg focus:outline-none"
            role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabindex="-1">
            <div class="py-1" role="none" (outsideClick)="closeActionMenu($event)" outside-click>
              <a routerLink="/profile" (click)="onClickDropdownMenu()"
                class="block px-4 py-2 text-sm-light hover:text-zinc-950 dark:hover:text-white" role="menuitem"
                tabindex="-1" id="menu-item-0">Profile</a>
              <a href="javascript:void(0)" (click)="logout()"
                class="block px-4 py-2  text-sm-light hover:text-zinc-950 dark:hover:text-white" role="menuitem"
                tabindex="-1" id="menu-item-0">Logout</a>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</header>

<audio #audioOption>
  <source src='assets/sound/notification_bell.mp3' type="audio/mp3">
</audio>
<!-- <app-notification-modal *ngIf="showNotifications" (closeModal)="showNotifications = false"></app-notification-modal> -->